import React, { ReactNode } from 'react';

type Props = {
  title?: string;
  children: ReactNode;
};

function Section({ children }: Props) {
  return <div className="mb-8 md:mb-14">{children}</div>;
}

function Header({ children }: { children: ReactNode }) {
  return <div className="flex justify-between items-center mb-3">{children}</div>;
}

function Title({ children }: { children: ReactNode }) {
  return <h2 className="font-bold text-xl md:text-2xl">{children}</h2>;
}

function Content({ children }: { children: ReactNode }) {
  return <>{children}</>;
}

export default Object.assign(Section, {
  Title,
  Header,
  Content,
});
